import { useCallback } from "react";
import { useTranslation } from "react-i18next";
import { useToast } from "./use-toast";

export function useSapWarningToast(): (result: { sapWarning?: string | null }) => void {
	const { t } = useTranslation();
	const { showToast } = useToast();
	return useCallback(
		(result: { sapWarning?: string | null }) => {
			if (!result?.sapWarning) return;
			showToast(t(`sapWarning.${result.sapWarning}`), "error");
		},
		[showToast, t],
	);
}
